import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cogoToast from 'cogo-toast';
import cn from 'classnames';

import './CallPreviewEditPanel.scss';

const CallPreviewEditPanel = (props) => {
  const { call, closePanel, closePanelAndResync, updateChatParticipant } = props;
  const [participants, setParticipants] = useState(call.participants || []);
  const [isSaving, setIsSaving] = useState(false);

  const canSave = !_.isEqual(participants, call.participants);

  const updateParticipant = (participant, updates) => setParticipants(participants.map((p) => (p.id === participant.id ? { ...p, ...updates } : p)));

  const saveResults = async () => {
    const reps = _.filter(participants, (p) => p.speaker_type === 'rep');
    if (reps.length !== 1) return cogoToast.warn(`You must define ${reps.length > 1 ? 'only' : 'at least'} one Representative for the call.`);

    const participantsRaw = call.participants.map(JSON.stringify);
    const updatedParticipants = participants.filter((p) => !participantsRaw.includes(JSON.stringify(p)));
    const updates = updatedParticipants.map(
      (p) =>
        new Promise(async (resolve) => {
          await updateChatParticipant(p, { name: p.name, speaker_type: p.speaker_type });
          resolve();
        })
    );

    setIsSaving(true);
    await Promise.all(updates);
    setIsSaving(false);

    // If changing rep, we must rerun.
    const prevRep = call.participants.find((p) => p.speaker_type === 'rep')?.id;
    const newRep = participants.find((p) => p.speaker_type === 'rep')?.id;
    const updatingRep = prevRep !== newRep;

    if (updatedParticipants.length) {
      updatingRep
        ? cogoToast.success(`Successfully updated ${updates.length} participant${participants.length === 1 ? '' : 's'}.`)
        : cogoToast.success(
            `Successfully updated ${updates.length} participant${
              participants.length === 1 ? '' : 's'
            }, rerunning analysis as the representative changed.`
          );
    }

    updatingRep ? closePanelAndResync() : closePanel();
  };

  return (
    <div className='call-preview-edit-panel-outer-container'>
      <div className='section'>
        <div className='section-header'>Edit Participants</div>
        <div className='participants'>
          {participants?.map((participant) => (
            <div key={participant.id} className='participant'>
              <input onChange={(e) => updateParticipant(participant, { name: e.target.value })} className='name' value={participant.name} />
              <div className='type-control'>
                {[
                  {
                    display: 'Representative',
                    variable: 'rep',
                  },
                  {
                    display: 'Customer',
                    variable: 'customer',
                  },
                ].map(({ display, variable }) => {
                  const active = participant.speaker_type === variable;
                  const select = () => !active && updateParticipant(participant, { speaker_type: variable });
                  return (
                    <div onClick={select} key={variable} className={cn('type', { active })}>
                      {display}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className='action-btns'>
        {canSave && (
          <div onClick={closePanel} className='action-btn cancel'>
            Cancel
          </div>
        )}
        <div onClick={canSave ? saveResults : closePanel} className='action-btn done'>
          {isSaving ? 'Saving...' : canSave ? 'Save' : 'Done'}
        </div>
      </div>
    </div>
  );
};

CallPreviewEditPanel.propTypes = {
  call: PropTypes.object.isRequired,
  closePanel: PropTypes.func.isRequired,
  updateChatParticipant: PropTypes.func.isRequired,
};

export default CallPreviewEditPanel;
